module.exports = __webpack_public_path__ + "images/interview-Meta-2.svg";